import { CheckIcon, XIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'

import * as S from './approve-decline-buttons.styled'

export interface ApproveDeclineButtonsProps extends React.HTMLAttributes<HTMLDivElement> {
  onApprove: () => void
  onDecline: () => void
  approveLoading?: boolean
  approveDisabled?: boolean
  declineLoading?: boolean
  declineDisabled?: boolean
}

export const ApproveDeclineButtons = ({
  onApprove,
  onDecline,
  approveLoading = false,
  approveDisabled = false,
  declineLoading = false,
  declineDisabled = false,
  onClick,
  ...props
}: ApproveDeclineButtonsProps) => (
  <S.Container
    {...props}
    onClick={(e) => {
      e.stopPropagation()
      onClick?.(e)
    }}
  >
    <S.DeclineButton
      onlyBox
      onlyCircle
      disabled={declineDisabled}
      loading={declineLoading}
      size="small"
      use="secondary"
      onClick={onDecline}
    >
      <Icon icon={XIcon} />
    </S.DeclineButton>
    <S.ApproveButton
      onlyBox
      onlyCircle
      disabled={approveDisabled}
      loading={approveLoading}
      size="small"
      use="secondary"
      onClick={onApprove}
    >
      <Icon icon={CheckIcon} />
    </S.ApproveButton>
  </S.Container>
)
